import { render } from "./post_choose.vue?vue&type=template&id=c3a7d1c8"
import script from "./post_choose.vue?vue&type=script&lang=js"
export * from "./post_choose.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__